/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordDateFieldComponent } from '../../admin/form/form-record/fields/date/form-record-date-field.component';
/* eslint-enable */

export class FormRecordDateFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordDateFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
